// import { student_essay, user_id } from './../services/College_name.service';
// import { Test_Taker } from './../test_taker/test_taker.model';
// import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
// import { MatPaginator } from '@angular/material/paginator';
// import { MatTableDataSource } from '@angular/material/table';
// import { College_Names, collegedetails, CollegeService, UserSet, scoreid } from '../services/College_name.service';
// import { Year } from '../services/year.service';
// import { Router, ActivatedRoute } from '@angular/router';
// import { MatIconModule } from '@angular/material/icon';
// import { MatPaginatorModule } from '@angular/material/paginator';
// import { MatSortModule, MatSort } from '@angular/material/sort';
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { MatDialogModule } from '@angular/material/dialog';
// import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { Local, questionService } from '../services/question.service';
// declare var $: any;
// declare let jQuery: any;
// import { DomSanitizer } from '@angular/platform-browser';
// import { last } from 'lodash';
// import { CompileShallowModuleMetadata } from '@angular/compiler';
// //import { ConsoleReporter } from 'jasmine';


// @Component({
//   selector: 'app-audio-view',
//   templateUrl: './audio-view.component.html',
//   styleUrls: ['./audio-view.component.scss']
// })
// export class AudioViewComponent implements OnInit {

//   Collegeid: any;
//   //mark:string = '';
//   @ViewChild("mark") modalMark: TemplateRef<any>;
//   hideModal: boolean;
//   score: scoreid = { userid: '', question_category_id: '',question_sub_category_id:'',question_type_id:"", complexity_id: '', correct_ans: '', mark: ''}
//   highlightedRows = [];
//   getscore: user_id = { user_id: '',type:''}
//   public dictionary: any;
//   public mark: string = '';
//   yearid: any;
//   Collegedetails: collegedetails = { collegeid: '', yearid: '',setid:'' };
//   userset: UserSet = { userid: '', setid: '',type_name:'' };
//   searchKey: string;
//   displayedColumns: string[] = ['S.No.', 'Roll_Number', 'First_Name', 'View_Audio' , 'View_Video','Audio_Marks','Video_Marks'];
//   evaluationDropDownFields: string[] = ['Evaluated','Not Evaluated'];
//   @ViewChild(MatSort, { static: true }) sort: MatSort;
//   @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
//   @ViewChild("content") modalContent: TemplateRef<any>;
//   userid: any;
//   local: Local = { Id: '', paper: '', set: '', schedule: '', email: '',schedule_master_Id:'' };
//   modalService: any;
//   essay: any;
//   college: any;
//   College_Name1: any;
//   Year_Name: any;
//   College_Name: any;
//   dataSource: MatTableDataSource<any>;
//   student: student_essay = {id:'',type:''};
//   show: boolean;
//   questions: any;
//   id: any;
//   cat_Id: any;
//   cat: string;
//   set: string;
//   paper: string;
//   qset: string;
//   essayqs: any;
//   questions1: any;
//   candidateid: any = [];
//   save_essay: any;
//   evaluated: any = [];
//   temp_report: any;
//   user_id: any;
//   userscore: any;
//   errorMsg: string;
//   IsmodelShow: boolean;
//   modalRef: any;
//   rowmark :any= [];
//   rowmarks :any= [];
//   audiomarks :any= [];
//   audiomark :any= [];
//   algmarks: any=[];
//   algmark:any=[];
//   videomarks: any=[];
//   videomark:any=[];
//   essayrowmark: any;
//   //emptydata: boolean = false;
//   essaypara: string;
//   updatemarks: boolean;
//   visible: boolean;
//   scorecheck: boolean;
//   percent: number;
//   alg: number = 0;
//   essay_data: any;
//   category_name: any;
//   no_data: boolean = true;
//   qsid: string;
//   user: string;
//   userAdmin: boolean;
//   userTestScheduler: boolean;
//   userSuperAdmin: boolean;
//   audiourl : any;
//   videourl : any;
//   marksMap: Map<string, number> = new Map();
//   displayMarksMap: Map<number,number> = new Map();
//   totalMarks: number = 0;
//   lastIndexArrived: boolean = false;
//   marksArray: number[] = [];
//   questionsArrayToEvaluate: any[] = [];
//   maps: any[] = [];
//   lastQuestion_Sub_Category_Id: any;
  

//   constructor(private router: Router,private domSanitizer: DomSanitizer, private fs: CollegeService, private modal: NgbModal, private route: ActivatedRoute, private quest: questionService) {
//     // this.display_essay();

//     this.dictionary = {
//       dictionaryUrl: "http://js.syncfusion.com/ejServices/api/SpellCheck/CheckWords",
//       customDictionaryUrl: "http://js.syncfusion.com/ejServices/api/SpellCheck/AddToDictionary"
//     };
//   }

//   sanitize(dataurl:string){
//     return this.domSanitizer.bypassSecurityTrustUrl(dataurl);
//   }

//   ngOnInit() {
//     this.getAccess();
//     this.marksMap;






//     //  this.rowmarks = []

//     this.audiomarks = JSON.parse(localStorage.getItem('audiomark'));
//     this.videomarks = JSON.parse(localStorage.getItem('videomark'));


//     if (this.audiomarks === undefined || this.audiomarks === null) {
//       localStorage.setItem("audiomark", JSON.stringify([111]))
//       this.audiomarks = JSON.parse(localStorage.getItem('audiomark'));
//     }
//     if (this.videomarks === undefined || this.videomarks === null) {
//       localStorage.setItem("videomark", JSON.stringify([111]))
//       this.videomarks = JSON.parse(localStorage.getItem('videomark'));
//     }
//     //this.rowmarks = Object.values(this.rowmarks);



//     this.qset = localStorage.getItem('qsid')

//     //this.dataSource.paginator = this.paginator;
//     this.display_candidates();

//     //  this.display_question();
//     this.route.params.subscribe(params => {
//       this.id = params['id'];
//       this.cat_Id = this.id;
//       this.cat = localStorage.getItem('Category-id');

//       this.set = localStorage.getItem('Set-id');

//       this.paper = localStorage.getItem('Paper-id');



//     });

//     this.local.Id = 3
//     this.local.set = this.set
//     this.local.paper = this.paper

//   }

  

//   getAccess(){
//     this.user = sessionStorage.getItem('user');
//     if (this.user === '2') {

//       this.userAdmin = true;
//       this.userSuperAdmin = false;
//       this.userTestScheduler = true;
//     } else if (this.user === '1') {

//       this.userAdmin = true;
//       this.userSuperAdmin = true;
//       this.userTestScheduler = true;
//     } else if (this.user === '3') {
//       this.userAdmin = false;
//       this.userSuperAdmin = false;
//       this.userTestScheduler = true;
//     }
//   }

//   display_audio(row){
//     this.userset.userid = row.id;
//     this.userset.type_name = 'AudioAnswer'
//     this.display_question(row);
//   }

//   display_video(row){
//     this.userset.userid = row.id;
//     this.userset.type_name = 'VideoAnswer'
//     this.display_question(row);
//   }

  

//   update() {
//     MathJax.Hub.Config({
//       showMathMenu: false,
//       // jax: ["input/TeX", "output/HTML-CSS"],
//       tex2jax: {
//         inlineMath: [['$', '$'], ['\\(', '\\)']],
//         //processEscapes: true,
//         // skipTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code']
//       },
//       menuSettings: { zoom: "Double-Click", zscale: "20%" },
//       CommonHTML: { linebreaks: { automatic: true } },
//       "HTML-CSS": { scale: 100, linebreaks: { automatic: true, width: "container" } },
//       SVG: { linebreaks: { automatic: true } }
//     });
//     setTimeout(() => {
//       MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.getElementsByClassName("answers")]);
//     }, 1000)


//   }

//   // display_essay_ans(row) {

//   //
//   //
//   //   //this.emptydata = false

//   //   // let ngbModalOptions: NgbModalOptions = {
//   //   //   backdrop: 'static',
//   //   //   keyboard: false,
//   //   // };
//   //   //



//   //
//   //

//   //
//   //   this.fs.display_essay(this.student).subscribe(
//   //     (data) => {

//   //
//   //       this.questions = data.results;
//   //       // if(data.results.length == 0){
//   //       //   this.emptydata = true
//   //       //   this.essaypara = 'No Essay'
//   //       // }
//   //
//   //       this.temp_report = data.results;
//   //
//   //       this.essay = data.results[0].Essay_Answer;
//   //

//   //     },
//   //     err => {
//   //       console.error(err);
//   //     }
//   //   );


//   // }

//   onSearchClear() {
//     this.searchKey = "";
//     this.applyFilter();
//   }

//   applyFilter() {
//     this.dataSource.filter = this.searchKey.trim().toLowerCase();
//   }
//   back() {
//     this.router.navigate(['evaluate_audio']);
//   }


//   display_candidates() {

//     this.Collegeid = localStorage.getItem('CollegeId')
//     this.qsid = localStorage.getItem('qsid')
//     this.yearid = localStorage.getItem('Yearid')
//     console.log(localStorage.getItem('Category-id'))
//     this.Collegedetails.collegeid = this.Collegeid;
//     this.Collegedetails.yearid = this.yearid;
//     this.Collegedetails.setid = this.qsid;


//     this.fs.display_audio_candidate(this.Collegedetails).subscribe(
//       (data) => {


//         this.college = data.results;
//         console.log(this.college);
//         //this.temp_report=data.results;
//         for (var i = 0; i < data.results.length; i++) {
//           this.candidateid[i] = data.results[i].id;

//         }



//         this.College_Name1 = this.college[0].College_Name

//         this.Year_Name = this.college[0].Year


//         //

//         this.dataSource = new MatTableDataSource(this.college);
//         this.dataSource.sort = this.sort;
//         setTimeout(() => this.dataSource.paginator = this.paginator);

//         // this.display_scoreid();
//       },
//       err => {
//         console.error(err);
//       }

//     );

//   }


//   display_question(row) {
//     this.no_data = true;

//     this.userset.setid = this.qset;

//      //Open modal on pressing escape
//      this.videourl = "";
//      this.audiourl = "";
//      let ngbModalOptions: NgbModalOptions = {
//       backdrop: 'static',
//       keyboard: false
//     };
//     this.modalRef = this.modal.open(this.modalContent, ngbModalOptions)
//     console.log("this.userset",this.userset)
//     this.fs.display_audioques(this.userset).subscribe(
//       (data) => {

//         console.log("adata",data.result)
//         this.questions1 = data.result
//         this.essay_data = data.result;
//         console.log(this.questions1);
//         if (this.essay_data === undefined || this.essay_data === null || this.essay_data.length ==0) {
//           // this.essay_data = 'No data available'
//           this.category_name = 'NO DATA';
//           this.no_data = false;
//           this.essay_data = [{  Essay_Answer: 'No data available' }];
//         }
//         else{
//           this.category_name = this.essay_data[0].Category_Name;
//           if(this.userset.type_name === 'AudioAnswer')
//           {

//             this.audiourl = 'data:audio/wav;base64,' + this.questions1[0].Audio_Answer;
//             this.videourl = "";
//           }
//           else{
//             this.videourl = 'data:video/mp4;base64,' + this.questions1[0].Audio_Answer;
//             this.audiourl = "";
//           }
          
//         }
//         //
//         // this.get_score(row)
//         this.showurl(this.questions1[0])
//         // for(var i=0;i<data.result.length;i++){
//         //   this.temp_report[i].Test_Taker_User_Id=false
//         // }

//       },
//       err => {
//         console.error("Error",err);
//       }
//     );



//   }
//   // display_scoreid(){

//   //

//   //   this.fs.display_scoreid(this.candidateid).subscribe(
//   //     (data) => {

//   //
//   //       this.questions1=data.result
//   //
//   //       this.essayqs = this.questions1[0].Question_Text;
//   //

//   //     },
//   //     err => {
//   //       console.error(err);
//   //     }
//   //   );
//   // }
//   get_audio_score(row){
//     this.getscore.type = 'AudioAnswer';
//     // this.get_score(row)
//   }
 
//   showurl(row){
    
//     this.getscore.user_id = row.Id;
//     this.getscore.type = row.Name;
//     this.fs.getscore(this.getscore).subscribe(
//       data => {

//       if(data.results.length >0)
//         this.userscore = data.results[0].score;
//       else{
//         this.userscore = 0;
//       }
//       console.log(this.userscore);
        

//         // if(this.userscore = 0){
//         //   this.scorecheck = true;
//         // }
//         // else{
//         //    this.scorecheck=false
//         // }

//       }
//     )



//   }


//   get_video_score(row){
//     this.getscore.type = 'VideoAnswer';
//     // this.get_score(row)
//   }

  
//   get_score(row) {
  
//       this.getscore.user_id = row.id
  
//       this.user_id = this.college
//       console.log(row);
     
//       console.log(this.getscore);
//       this.fs.getscore(this.getscore).subscribe(
//         data => {
  
//         if(data.results.length >0)
//           this.userscore = data.results[0].score;
//         else{
//           this.userscore = 0;
//         }
//         console.log(this.userscore);
          
  
//           // if(this.userscore = 0){
//           //   this.scorecheck = true;
//           // }
//           // else{
//           //    this.scorecheck=false
//           // }
  
//         }
//       )
//     }
//     getmarks(row) {
  
  
//      console.log("Printing the row ....",row);
//      console.log("Printing score ",this.score);
  
//       //this.rowmarks = []
//       this.audiomarks = JSON.parse(localStorage.getItem('audiomark'));
//       this.videomarks = JSON.parse(localStorage.getItem('videomark'));
//       //this.rowmarks = Object.values(this.rowmarks);
  
 
//   console.log("Total Marks ",this.totalMarks);
//       console.log("Printing this.user score",this.userscore);
      
  
  
//       //this.highlightedRows.push(this.rowmark)
//       if (this.userscore == undefined) {
//         const modalRef = this.modal.open(this.modalMark)
//         this.errorMsg = "Marks field is empty"
//       }
//       else if (this.userscore > 100) {
//         const modalRef = this.modal.open(this.modalMark)
//         this.errorMsg = "Enter marks below 100%"
//       }
//       else if (this.userscore < 0 || this.userscore == 0) {
//         const modalRef = this.modal.open(this.modalMark)
//         this.errorMsg = "Enter valid marks"
//       }
//       else {
//         this.modalRef.close(this.modalContent)
  
  
  
//          console.log("Row.Name ",row.Name);
//             if(row.Name == 'AudioAnswer'){
              
//             this.audiomarks.push(row.Roll_Number)
//             console.log("Row.RollNumber Value :",row.Roll_Number);
//             console.log("Audio Marks Entered : ",this.audiomarks)
//             localStorage.setItem("audiomark", JSON.stringify(this.audiomarks))
//             }
//             else{
//               this.videomarks.push(row.Roll_Number)
//               console.log(row.Roll_Number)
//               localStorage.setItem("videomark", JSON.stringify(this.videomarks))
//           }
          
  
  
        
  
//         //this.rowmarks = Object.values(this.rowmarks);
  
//           console.log(`row******`,row)
//         var pushArray: any[] = [];
//         for(var i =0;i<row.length;i++){
//           console.log("Printing the question type id ",row[i].Category_Name);
//         this.score.userid = row[i].Test_Taker_User_Id;
//         console.log("This .score .user id",this.score.userid);
//         this.score.complexity_id = row[i].Complexity_Id;
//         this.score.question_category_id = row[i].Question_Category_Id;
//         this.score.question_sub_category_id = row[i].Question_Sub_Category_Id;
//         this.score.correct_ans = this.questions1.length;
//         this.score.question_type_id = row[i].Category_Name;
//         // this.score.mark = this.userscore;
//         this.score.mark = String(this.totalMarks);
//         pushArray.push(this.score);

//         console.log("THIS.Score ",this.score);
//         console.log("Push Array ",pushArray);

        

//         // this.score.question_type_id = 
//         }
//         console.log("THIS.Score outer ",this.score);
  
//         // this.changecolor(ro w)
//         // console.log(this.score)
//         this.fs.save_essay_mark(this.score).subscribe(
//           data => {
//             this.save_essay = data.results;
  
//           },
//           err => {
//             console.error(err);
//           }
//         );
      
//     }
//     }
  
//        checkErrors() {
//         let spellObj = $('#SpellCheck').data('ejSpellCheck');
//         spellObj.validate();
//     }
  
//     changecolor(row) {
    
//       let color;
//       //let color;
    
//       if (this.essayrowmark.indexOf(row.Roll_Number) > -1) {
  
//         color = 'rgb(23, 162, 184)';
//       }
//       return color;
//     }

//     // getmarks(row) {
//     //   console.log("P row :",row);
//     //   for(var i=0;i<row.length;i++){
//     //   this.audiomarks = JSON.parse(localStorage.getItem('audiomark'));
//     //   this.videomarks = JSON.parse(localStorage.getItem('videomark'));
    
//     //   console.log("Printing this.user Total score", this.totalMarks);
//     //   console.log("USER SCORE",this.userscore);
    
//     //   if (this.userscore === undefined) {
//     //     const modalRef = this.modal.open(this.modalMark);
//     //     this.errorMsg = "Marks field is empty";
//     //   } else if (this.userscore > 100) {
//     //     const modalRef = this.modal.open(this.modalMark);
//     //     this.errorMsg = "Enter marks below 100%";
//     //   } else if (this.userscore < 0 || this.userscore === 0) {
//     //     const modalRef = this.modal.open(this.modalMark);
//     //     this.errorMsg = "Enter valid marks";
//     //   } else {
//     //     this.modalRef.close(this.modalContent);
//     //     console.log("Row Name ")
//     //     if (row.Name === 'AudioAnswer') {
//     //       if (!this.audiomarks) {
//     //         this.audiomarks = [];
//     //       }
//     //       this.audiomarks.push({
//     //         Roll_Number: row.Roll_Number,
//     //         Marks: this.userscore
//     //       });
//     //       console.log("Row.RollNumber Value :", row.Roll_Number);
//     //       console.log("Audio Marks Entered:", this.audiomarks);
//     //       localStorage.setItem("audiomark", JSON.stringify(this.audiomarks));
//     //     } else {
//     //       if (!this.videomarks) {
//     //         this.videomarks = [];
//     //       }
//     //       this.videomarks.push({
//     //         Roll_Number: row.Roll_Number,
//     //         Marks: this.userscore
//     //       });
//     //       console.log(row.Roll_Number);
//     //       localStorage.setItem("videomark", JSON.stringify(this.videomarks));
//     //     }
    
//     //     this.score.userid = row.Test_Taker_User_Id;
//     //     this.score.complexity_id = row.Complexity_Id;
//     //     this.score.question_category_id = row.Question_Category_Id;
//     //     this.score.question_sub_category_id = row.Question_Sub_Category_Id;
//     //     this.score.correct_ans = this.questions1.length;
//     //     this.score.mark = this.userscore;
//     //     console.log(this.score);
//     //     this.fs.save_essay_mark(this.score).subscribe(
//     //       data => {
//     //         this.save_essay = data.results;
//     //       },
//     //       err => {
//     //         console.error(err);
//     //       }
//     //     );
//     //   }
//     // }
//     // }
    
  
//     change_visibility(row) {
  
//       let visibility;
//       if (this.essayrowmark.indexOf(row.Roll_Number) > -1) {
//         visibility = 'hidden';
//         this.visible = true;
//       }
  
//     }

//     showEvaluatedOrNotEvaluated(){
//       console.log("Clicked ");
  
//       this.dataSource = new MatTableDataSource(this.college);
//       this.dataSource.sort = this.sort;
  
//       }




//       storeData(map, id, value) {
//         if (!map.has(id)) {
//           map.set(id, []);
//         }
//         map.get(id).push(value);
//       }



      

// //maps: number[] = [];
//       pushMarksIntoMarksMap(field,row){
        
//         // console.log("Input data in text area ",field);

//         // console.log("ROW :",row);
//         // console.log("2123",row.Question_Sub_Category_Id);


       


//         // if (this.marksMap.has(row.Question_Sub_Category_Id)) {
          
//         //   const currentValue = Number(this.marksMap.get(row.Question_Sub_Category_Id));
//         //   this.marksMap.set(row.Question_Sub_Category_Id, currentValue + Number(field));
//         // } else {
          
//         //   this.marksMap.set(row.Question_Sub_Category_Id, field);
//         // }

//         // console.log("Marks Map Printing here .....",this.marksMap);
       
       
//         this.questionsArrayToEvaluate.push(row);
//         console.log("Questions array to evaluate : ",this.questionsArrayToEvaluate);
//         this.totalMarks = 0;

// console.log("RROWW",row);

// this.displayMarksMap.set(row.Question_Id,field);

// console.log("Printing the display marks map ",this.displayMarksMap);


//   if (this.marksMap.has(row.Question_Sub_Category_Id)) {
//   const currentValue = Number(this.marksMap.get(row.Question_Sub_Category_Id));
//   const newMarks = currentValue + Number(field);
//   this.marksMap.set(row.Question_Sub_Category_Id, newMarks);
//   this.totalMarks += newMarks;
//     } else {
//   const newMarks = Number(field);
//   this.marksMap.set(row.Question_Sub_Category_Id, newMarks);
//   this.totalMarks += newMarks;
// }

// console.log("Marks Map Printing here .....", this.marksMap);
// console.log("Total Marks: ", this.totalMarks);


      
//       }
      
//   }




import { student_essay, user_id } from './../services/College_name.service';
import { Test_Taker } from './../test_taker/test_taker.model';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { College_Names, collegedetails, CollegeService, UserSet, scoreid } from '../services/College_name.service';
import { Year } from '../services/year.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Local, questionService } from '../services/question.service';
declare var $: any;
declare let jQuery: any;
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-audio-view',
  templateUrl: './audio-view.component.html',
  styleUrls: ['./audio-view.component.scss']
})
export class AudioViewComponent implements OnInit {

  Collegeid: any;
  //mark:string = '';
  @ViewChild("mark") modalMark: TemplateRef<any>;
  hideModal: boolean;
  score: scoreid = {
    userid: '', question_category_id: '', complexity_id: '', correct_ans: '', mark: '',
    question_type_id: '',
    question_sub_category_id: '',comments:""
  }
  highlightedRows = [];
  getscore: user_id = { user_id: '',type:''}
  public dictionary: any;
  public mark: string = '';
  yearid: any;
  Collegedetails: collegedetails = { collegeid: '', yearid: '',setid:'' };
  userset: UserSet = { userid: '', setid: '',type_name:'' };
  searchKey: string;
  displayedColumns: string[] = ['S.No.', 'Roll_Number', 'First_Name', 'View_Audio' , 'View_Video','Audio_Marks','Video_Marks'];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("content") modalContent: TemplateRef<any>;
  userid: any;
  local: Local = { Id: '', paper: '', set: '', schedule: '', email: '',schedule_master_Id:'' };
  modalService: any;
  essay: any;
  college: any;
  College_Name1: any;
  Year_Name: any;
  College_Name: any;
  dataSource: MatTableDataSource<any>;
  student: student_essay = {id:'',type:''};
  show: boolean;
  questions: any;
  audioMarks=new Map<String,Array<any>>()
  id: any;
  cat_Id: any;
  cat: string;
  set: string;
  paper: string;
  qset: string;
  essayqs: any;
  questions1: any;
  candidateid: any = [];
  save_essay: any;
  evaluated: any = [];
  temp_report: any;
  user_id: any;
  userscore: any;
  errorMsg: string;
  IsmodelShow: boolean;
  modalRef: any;
  rowmark :any= [];
  rowmarks :any= [];
  audiomarks :any= [];
  audiomark :any= [];
  algmarks: any=[];
  algmark:any=[];
  videomarks: any=[];
  videomark:any=[];
  essayrowmark: any;
  //emptydata: boolean = false;
  essaypara: string;
  updatemarks: boolean;
  visible: boolean;
  scorecheck: boolean;
  percent: number;
  alg: number = 0;
  essay_data: any;
  category_name: any;
  no_data: boolean = true;
  qsid: string;
  user: string;
  userAdmin: boolean;
  userTestScheduler: boolean;
  userSuperAdmin: boolean;
  audiourl : any;
  videourl : any;
  displayMarksMap: Map<number,number> = new Map();
  totalMarks: number = 0;
  questionsArrayToEvaluate: any[] = [];
  marksMap: Map<string, number> = new Map();
  dataSourceArray: any[] = [];
  audioFilteredArray: any[] = [];
  evaluationDropDownFields: string[] = ['Evaluated','Not Evaluated','Show All'];
  RollNumberFilteredArray: any[] = [];
  audioEvaluatedFilteredArray: any[] = [];
  matchingEvaluatedValuesOfAudio: any[] = [];
  MatchingEvaluatedValuesWithoutDuplicatesOfAudio: any[] = [];
  matchingEvaluatedValuesOfVideo: any[] = [];
  MatchingEvaluatedValuesWithoutDuplicatesOfVideo: any[] = [];
  finalEvaluatedArray: any[] = [];
  finalNonEvaluatedArray: any[] = [];
  allDataSourceArray: any[] = [];
  optedValue: any;
  allDataSourceArrayWithoutDuplicates: any[] = [];
  matchingElementsNonEvaluated: any[] = [];
  currentElementOfNonEvaluated: any;
  currentElementOfEvaluated: any;
  matchingElementsEvaluated: any[] = [];
  matchingElementsNonEvaluatedWithoutDuplicates: any[] = [];
  matchingElementsEvaluatedWithoutDuplicates: any[] = [];

  constructor(private router: Router,private domSanitizer: DomSanitizer, private fs: CollegeService, private modal: NgbModal, private route: ActivatedRoute, private quest: questionService) {
    // this.display_essay();

    this.dictionary = {
      dictionaryUrl: "http://js.syncfusion.com/ejServices/api/SpellCheck/CheckWords",
      customDictionaryUrl: "http://js.syncfusion.com/ejServices/api/SpellCheck/AddToDictionary"
    };
  }

  sanitize(dataurl:string){
    return this.domSanitizer.bypassSecurityTrustUrl(dataurl);
  }

  ngOnInit() {
    this.getAccess();

console.log("Opted val",this.optedValue)




    //  this.rowmarks = []

    this.audiomarks = JSON.parse(localStorage.getItem('audiomark'));
    this.videomarks = JSON.parse(localStorage.getItem('videomark'));


    if (this.audiomarks === undefined || this.audiomarks === null) {
      localStorage.setItem("audiomark", JSON.stringify([111]))
      this.audiomarks = JSON.parse(localStorage.getItem('audiomark'));
    }
    if (this.videomarks === undefined || this.videomarks === null) {
      localStorage.setItem("videomark", JSON.stringify([111]))
      this.videomarks = JSON.parse(localStorage.getItem('videomark'));
    }
    //this.rowmarks = Object.values(this.rowmarks);



    this.qset = localStorage.getItem('qsid')

    //this.dataSource.paginator = this.paginator;
    this.display_candidates();

    //  this.display_question();
    this.route.params.subscribe(params => {
      this.id = params['id'];
      this.cat_Id = this.id;
      this.cat = localStorage.getItem('Category-id');

      this.set = localStorage.getItem('Set-id');

      this.paper = localStorage.getItem('Paper-id');



    });

    this.local.Id = 3
    this.local.set = this.set
    this.local.paper = this.paper

  }

  

  getAccess(){
    this.user = sessionStorage.getItem('user');
    if (this.user === '2') {

      this.userAdmin = true;
      this.userSuperAdmin = false;
      this.userTestScheduler = true;
    } else if (this.user === '1') {

      this.userAdmin = true;
      this.userSuperAdmin = true;
      this.userTestScheduler = true;
    } else if (this.user === '3') {
      this.userAdmin = false;
      this.userSuperAdmin = false;
      this.userTestScheduler = true;
    }
  }

  display_audio(row){
    this.userset.userid = row.id;
    this.userset.type_name = 'AudioAnswer'
    this.display_question(row);
  }

  display_video(row){
    this.userset.userid = row.id;
    this.userset.type_name = 'VideoAnswer'
    this.display_question(row);
  }

  // display_essay_ans(row) {

  //
  //
  //   //this.emptydata = false

  //   // let ngbModalOptions: NgbModalOptions = {
  //   //   backdrop: 'static',
  //   //   keyboard: false,
  //   // };
  //   //



  //
  //

  //
  //   this.fs.display_essay(this.student).subscribe(
  //     (data) => {

  //
  //       this.questions = data.results;
  //       // if(data.results.length == 0){
  //       //   this.emptydata = true
  //       //   this.essaypara = 'No Essay'
  //       // }
  //
  //       this.temp_report = data.results;
  //
  //       this.essay = data.results[0].Essay_Answer;
  //

  //     },
  //     err => {
  //       console.error(err);
  //     }
  //   );


  // }

  onSearchClear() {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter() {
    this.dataSource.filter = this.searchKey.trim().toLowerCase();
  }
  back() {
    this.router.navigate(['evaluate_audio']);
  }


  display_candidates() {

    this.Collegeid = localStorage.getItem('CollegeId')
    this.qsid = localStorage.getItem('qsid')
    this.yearid = localStorage.getItem('Yearid')
    console.log(localStorage.getItem('Category-id'))
    this.Collegedetails.collegeid = this.Collegeid;
    this.Collegedetails.yearid = this.yearid;
    this.Collegedetails.setid = this.qsid;


    this.fs.display_audio_candidate(this.Collegedetails).subscribe(
      (data) => {


        this.college = data.results;
        console.log(this.college);
        //this.temp_report=data.results;
        for (var i = 0; i < data.results.length; i++) {
          this.candidateid[i] = data.results[i].id;

        }



        this.College_Name1 = this.college[0].College_Name

        this.Year_Name = this.college[0].Year


        //

        this.dataSource = new MatTableDataSource(this.college);
        // this.dataSource = new MatTableDataSource();
        this.dataSource.sort = this.sort;
        setTimeout(() => this.dataSource.paginator = this.paginator);

        // this.display_scoreid();
      },
      err => {
        console.error(err);
      }

    );

  }


  display_question(row) {
    this.no_data = true;

    this.userset.setid = this.qset;

     //Open modal on pressing escape
     this.videourl = "";
     this.audiourl = "";
     let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalRef = this.modal.open(this.modalContent, ngbModalOptions)
    this.fs.display_audioques(this.userset).subscribe(
      (data) => {


        this.questions1 = data.result
        this.essay_data = data.result;
        console.log(this.questions1);
        if (this.essay_data === undefined || this.essay_data === null || this.essay_data.length ==0) {
          // this.essay_data = 'No data available'
          this.category_name = 'NO DATA';
          this.no_data = false;
          this.essay_data = [{  Essay_Answer: 'No data available' }];
        }
        else{
          this.category_name = this.essay_data[0].Category_Name;
          if(this.userset.type_name === 'AudioAnswer')
          {

            this.audiourl = 'data:audio/wav;base64,' + this.questions1[0].Audio_Answer;
            this.videourl = "";
          }
          else{
            this.videourl = 'data:video/mp4;base64,' + this.questions1[0].Audio_Answer;
            this.audiourl = "";
          }
          
        }
        //
        // this.get_score(row)
        this.showurl(this.questions1[0])
        // for(var i=0;i<data.result.length;i++){
        //   this.temp_report[i].Test_Taker_User_Id=false
        // }

      },
      err => {
        console.error("Error",err);
      }
    );



  }
  // display_scoreid(){

  //

  //   this.fs.display_scoreid(this.candidateid).subscribe(
  //     (data) => {

  //
  //       this.questions1=data.result
  //
  //       this.essayqs = this.questions1[0].Question_Text;
  //

  //     },
  //     err => {
  //       console.error(err);
  //     }
  //   );
  // }
  get_audio_score(row){
    this.getscore.type = 'AudioAnswer';
    // this.get_score(row)
  }
 
  showurl(row){
    
    this.getscore.user_id = row.Id;
    this.getscore.type = row.Name;
    this.fs.getscore(this.getscore).subscribe(
      data => {

      if(data.results.length >0)
        this.userscore = data.results[0].score;
      else{
        this.userscore = 0;
      }
      console.log(this.userscore);
        

        // if(this.userscore = 0){
        //   this.scorecheck = true;
        // }
        // else{
        //    this.scorecheck=false
        // }

      }
    )



  }


  get_video_score(row){
    this.getscore.type = 'VideoAnswer';
    // this.get_score(row)
  }

  
  get_score(row) {
  
      this.getscore.user_id = row.id
  
      this.user_id = this.college
      console.log(row);
     
      console.log(this.getscore);
      this.fs.getscore(this.getscore).subscribe(
        data => {
  
        if(data.results.length >0)
          this.userscore = data.results[0].score;
        else{
          this.userscore = 0;
        }
        console.log(this.userscore);
          
  
          // if(this.userscore = 0){
          //   this.scorecheck = true;
          // }
          // else{
          //    this.scorecheck=false
          // }
  
        }
      )
    }
    // getmarks(row) {
  
  
    //  console.log(row);
  
    //   //this.rowmarks = []
    //   this.audiomarks = JSON.parse(localStorage.getItem('audiomark'));
    //   this.videomarks = JSON.parse(localStorage.getItem('videomark'));
    //   //this.rowmarks = Object.values(this.rowmarks);
  
  
  
    //   console.log(this.userscore);
  
  
    //   //this.highlightedRows.push(this.rowmark)
    //   if (this.userscore == undefined) {
    //     const modalRef = this.modal.open(this.modalMark)
    //     this.errorMsg = "Marks field is empty"
    //   }
    //   else if (this.userscore > 100) {
    //     const modalRef = this.modal.open(this.modalMark)
    //     this.errorMsg = "Enter marks below 100%"
    //   }
    //   else if (this.userscore < 0 || this.userscore == 0) {
    //     const modalRef = this.modal.open(this.modalMark)
    //     this.errorMsg = "Enter valid marks"
    //   }
    //   else {
    //     this.modalRef.close(this.modalContent)
  
  
  
         
    //         if(row.Name == 'AudioAnswer'){
    //         this.audiomarks.push(row.Roll_Number)
    //         console.log(this.audiomarks)
    //         localStorage.setItem("audiomark", JSON.stringify(this.audiomarks))
    //         }
    //         else{
    //           this.videomarks.push(row.Roll_Number)
    //           console.log(row.Roll_Number)
    //           localStorage.setItem("videomark", JSON.stringify(this.videomarks))
    //       }
          
  
  
        
  
    //     //this.rowmarks = Object.values(this.rowmarks);
  
  
  
  
    //     this.score.userid = row.Test_Taker_User_Id;
    //     this.score.complexity_id = row.Complexity_Id;
    //     this.score.question_category_id = row.Question_Category_Id;
    //     this.score.correct_ans = this.questions1.length;
    //     this.score.mark = this.userscore;

  
    //     // this.changecolor(ro w)
    //     console.log(this.score)
    //     this.fs.save_essay_mark(this.score).subscribe(
    //       data => {
    //         this.save_essay = data.results;
  
    //       },
    //       err => {
    //         console.error(err);
    //       }
    //     );
    //   }
    // }
  
    //    checkErrors() {
    //     let spellObj = $('#SpellCheck').data('ejSpellCheck');
    //     spellObj.validate();
    // }
  
    // changecolor(row) {
    //
    //   let color;
    //   //let color;
    //
    //   if (this.essayrowmark.indexOf(row.Roll_Number) > -1) {
  
    //     color = 'rgb(23, 162, 184)';
    //   }
    //   return color;
    // }

   

    getmarks(row) {  
  
     console.log("Printing the row ....",row);
     console.log("Printing score ",this.score);
  
      //this.rowmarks = []
      this.audiomarks = JSON.parse(localStorage.getItem('audiomark'));
      this.videomarks = JSON.parse(localStorage.getItem('videomark'));
      //this.rowmarks = Object.values(this.rowmarks);
  
 
  console.log("Total Marks ",this.totalMarks);
      
  
  for(let j=0;j<row.length;j++){
    console.log("Printing this.user score",this.displayMarksMap.get(row[j].Question_Id));

      //this.highlightedRows.push(this.rowmark)
      if (this.displayMarksMap.get(row[j].Question_Id) == undefined) {
        const modalRef = this.modal.open(this.modalMark)
        this.errorMsg = "Marks field is empty"
      }
      else if (this.displayMarksMap.get(row[j].Question_Id) > 100) {
        const modalRef = this.modal.open(this.modalMark)
        this.errorMsg = "Enter marks below 100%"
      }
      else if (this.displayMarksMap.get(row[j].Question_Id) < 0 || this.displayMarksMap.get(row[j].Question_Id) == 0) {
        const modalRef = this.modal.open(this.modalMark)
        this.errorMsg = "Enter valid marks"
      }
      else {
        this.modalRef.close(this.modalContent)
  
        console.log("Essay data ",this.essay_data);
        console.log(`row******`,row);

        for(var i =0;i<row.length;i++){
         console.log("Row.Name ",row[i].Name);
            if(row[i].Name == 'AudioAnswer'){
              
            this.audiomarks.push(row[i].Roll_Number)
            console.log("Row.RollNumber Value :",row[i].Roll_Number);
            console.log("Audio Marks Entered : ",this.audiomarks)
            localStorage.setItem("audiomark", JSON.stringify(this.audiomarks))
            }
            else{
              this.videomarks.push(row[i].Roll_Number)
              console.log(row[i].Roll_Number)
              localStorage.setItem("videomark", JSON.stringify(this.videomarks))
          }
          
  
  
        
  
        //this.rowmarks = Object.values(this.rowmarks);
  
        var pushArray: any[] = [];
        
          console.log("Printing the question type id ",row[i].Category_Name);
          console.log("Type Id 1 ",row[i].cat_Id)
        this.score.userid = row[i].Test_Taker_User_Id;
        console.log("This .score .user id",this.score.userid);
        this.score.complexity_id = row[i].Complexity_Id;
      
        this.score.question_category_id = row[i].Question_Category_Id;
        this.score.question_sub_category_id = row[i].Question_Sub_Category_Id;
        console.log("Score.question_sub_category_id",this.score.question_sub_category_id);
        this.score.correct_ans = this.questions1.length;
        console.log("Questions 1",this.questions1);
        // this.score.question_type_id = this.questions1.Question_Type_Id
          this.score.question_type_id = row[i].Question_Type_Id;
        console.log("Check print of Question Type Id", this.score.question_type_id)
        console.log("Check print of Question Type Id 2",  this.questions1.Question_Type_Id)
        // this.score.mark = this.userscore;
        this.score.mark = String(this.totalMarks);
        pushArray.push(this.score);

        console.log("THIS.Score ",this.score);
        console.log("Push Array ",pushArray);

        

        // this.score.question_type_id = 
        }
        console.log("THIS.Score outer ",this.score);
  
        // this.changecolor(ro w)
        // console.log(this.score)
        this.fs.save_essay_mark(this.score).subscribe(
          data => {
            this.save_essay = data.results;
  
          },
          err => {
            console.error(err);
          }
        );
      
    }
  }
    }
  
       checkErrors() {
        let spellObj = $('#SpellCheck').data('ejSpellCheck');
        spellObj.validate();
    }
  
    changecolor(row) {
    
      let color;
      //let color;
    
      if (this.essayrowmark.indexOf(row.Roll_Number) > -1) {
  
        color = 'rgb(23, 162, 184)';
      }
      return color;
    }



  
    change_visibility(row) {
  
      let visibility;
      if (this.essayrowmark.indexOf(row.Roll_Number) > -1) {
        visibility = 'hidden';
        this.visible = true;
      }
  
    }



    pushMarksIntoMarksMap(field,row){
      console.log("field",field)
        
             
             
              this.questionsArrayToEvaluate.push(row);
              console.log("Questions array to evaluate : ",this.questionsArrayToEvaluate);
              this.totalMarks = 0;
      
      console.log("RROWW",row);
      
      this.displayMarksMap.set(row.Question_Id,field);
      
      console.log("Printing the display marks map ",this.displayMarksMap);
      
      
        if (this.marksMap.has(row.Question_Sub_Category_Id)) {
        const currentValue = Number(this.marksMap.get(row.Question_Sub_Category_Id));
        const newMarks = currentValue + Number(field);
        this.marksMap.set(row.Question_Sub_Category_Id, newMarks);
        this.totalMarks += newMarks;
        this.audioMarks.set(row.Question_Type_Id,[this.totalMarks])
          } else {
        const newMarks = Number(field);
        this.marksMap.set(row.Question_Sub_Category_Id, newMarks);
        this.totalMarks += newMarks;
      }


      
      console.log("Marks Map Printing here .....", this.marksMap);
      console.log("Total Marks: ", this.totalMarks);
      
      
            
            }

            __spreadArray(to, from) {
              for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
                to[j] = from[i];
              return to;
            }

            removeDuplicatesInArray(arr) {
              return arr.filter((item,
                  index) => arr.indexOf(item) === index);
          }

              
          showEvaluatedOrNotEvaluated(event :any){
              console.log("Clicked ");
          
        
              console.log("Printing the datasource ",this.dataSource);
              console.log("Filtered data inside the data source ",this.dataSource.filteredData)
        
              console.log("Audio Marks",this.audiomarks);
              console.log("Video Marks",this.videomarks);
        
              //this.dataSourceArray.push(this.dataSource.filteredData)
              this.__spreadArray(this.dataSourceArray,this.dataSource.filteredData);
              console.log("Printing the roll Number ",this.dataSourceArray)
              for(var i =0;i<this.dataSourceArray.length;i++){

              }
              console.log("PRINTING THE DATA SOURCE ARRAY .... ",this.dataSourceArray);
              //intersect_arrays(this.audiomarks,this.dataSourceArray);
               
              console.log("Printing the audio filtered array ",this.audioFilteredArray);

              for(var i = 0;i<this.dataSourceArray.length;i++){
                this.RollNumberFilteredArray.push(this.dataSourceArray[i].Roll_Number);
              }

              console.log("Prr of RollNumber Filtered Array ",this.RollNumberFilteredArray);


              // this.audioEvaluatedFilteredArray = this.dataSourceArray.filter(element => this.RollNumberFilteredArray.includes(element));
              // console.log("Audio Evaluated Array ",this.audioEvaluatedFilteredArray);


              //Logic For Filtering the data of the audio marks Evaluated
              for (let i = 0; i < this.audiomarks.length; i++) {
                
                for (let j = 0; j < this.RollNumberFilteredArray.length; j++) {
                  
                  if (this.audiomarks[i] === this.RollNumberFilteredArray[j]) {
                    console.log("audioMarks Matched ",this.audiomarks[i]);
                    this.matchingEvaluatedValuesOfAudio.push(this.audiomarks[i]);
                  }
                }
              }
              
              console.log("Matching Values",this.matchingEvaluatedValuesOfAudio);

              this.MatchingEvaluatedValuesWithoutDuplicatesOfAudio = this.removeDuplicatesInArray(this.matchingEvaluatedValuesOfAudio);

              console.log("Printing the final Evaluated Array Of Audio ",this.MatchingEvaluatedValuesWithoutDuplicatesOfAudio);



              //Logic For Filtering the data of the video marks Evaluated
              for (let i = 0; i < this.videomarks.length; i++) {
                
                for (let j = 0; j < this.RollNumberFilteredArray.length; j++) {
                  
                  if (this.videomarks[i] === this.RollNumberFilteredArray[j]) {
                    console.log("videoMarks Matched ",this.videomarks[i]);
                    this.matchingEvaluatedValuesOfVideo.push(this.videomarks[i]);
                  }
                }
              }
              
              console.log("Matching Values",this.matchingEvaluatedValuesOfVideo);

              this.MatchingEvaluatedValuesWithoutDuplicatesOfVideo = this.removeDuplicatesInArray(this.matchingEvaluatedValuesOfVideo);

              console.log("Printing the final Evaluated Array Of Video ",this.MatchingEvaluatedValuesWithoutDuplicatesOfVideo);


              //Storing all the final evlualted and Non Evaluated values
              for (let i = 0; i < this.MatchingEvaluatedValuesWithoutDuplicatesOfAudio.length; i++) {
                
                for (let j = 0; j < this.MatchingEvaluatedValuesWithoutDuplicatesOfVideo.length; j++) {
                  
                  if (this.MatchingEvaluatedValuesWithoutDuplicatesOfAudio[i] === this.MatchingEvaluatedValuesWithoutDuplicatesOfVideo[j]) {
                   console.log("Both case Matched and Evaluation done and the Roll Number is :  ",this.MatchingEvaluatedValuesWithoutDuplicatesOfAudio[i]);
                    this.finalEvaluatedArray.push(this.MatchingEvaluatedValuesWithoutDuplicatesOfAudio[i]);
                  }
                }
              }


              for (let i = 0; i < this.RollNumberFilteredArray.length; i++) {
                
                for (let j = 0; j < this.finalEvaluatedArray.length; j++) {
                  
                  if (this.RollNumberFilteredArray[i] === this.finalEvaluatedArray[j]) {
                   
                    //this.finalNonEvaluatedArray.push(this.RollNumberFilteredArray[i]);
                  }else{
                    this.finalNonEvaluatedArray.push(this.RollNumberFilteredArray[i]);
                  }
                }
              }

              
              console.log("Printing the finalEvalated Array ",this.finalEvaluatedArray)
              console.log("Printing the finalNonEvalauted Array",this.finalNonEvaluatedArray)




              //Logic for displaying in the front end
              this.__spreadArray(this.allDataSourceArray,this.dataSource.filteredData);
              console.log("Printing the AllDataSourceArray ",this.allDataSourceArray);

              this.optedValue = event;
              console.log("Printing the optedValue ",this.optedValue);

              //Logic for bringing all the elements in the data Array Evaluated
              

            for (var i = 0; i < this.dataSourceArray.length; i++) {
               this.currentElementOfEvaluated = this.dataSourceArray[i];

                    if (this.finalEvaluatedArray.includes(this.currentElementOfEvaluated.Roll_Number)) {
                     this.matchingElementsEvaluated.push(this.currentElementOfEvaluated);
                   }
              }

            console.log("Matching Elements:", this.matchingElementsEvaluated);

            //Logic for bringing all the elements in the data Array Non Evaluated
            
              console.log("DAta array Printing ",this.dataSourceArray);
              console.log("Non Evluated array printing",this.finalNonEvaluatedArray);
            for (var i = 0; i < this.dataSourceArray.length; i++) {
               this.currentElementOfNonEvaluated = this.dataSourceArray[i];

                    if (this.finalNonEvaluatedArray.includes(this.currentElementOfNonEvaluated.Roll_Number)) {
                     this.matchingElementsNonEvaluated.push(this.currentElementOfNonEvaluated);
                   }
              }

            console.log("Matching Elements 2:", this.matchingElementsNonEvaluated);

            //Logic for bringing all the elements in the data Array Non Evaluated
            console.log("All Data Source printing ",this.allDataSourceArray);
            this.allDataSourceArrayWithoutDuplicates = this.removeDuplicatesInArray(this.allDataSourceArray);
            console.log("Printing without duplicates",this.allDataSourceArrayWithoutDuplicates)

              if(this.optedValue == 'Evaluated'){
               this.dataSource.filteredData = [];
                console.log("Printing only the evaluated data");
                //this.dataSource.filteredData = this.matchingElementsEvaluated;
                console.log("Matching el eva",this.matchingElementsEvaluated);
                console.log("printing after push Evaluated ",this.dataSource);
                this.matchingElementsEvaluatedWithoutDuplicates = this.removeDuplicatesInArray(this.matchingElementsEvaluated)
                this.dataSource = new MatTableDataSource(this.matchingElementsEvaluatedWithoutDuplicates);
              }else if(this.optedValue == 'Not Evaluated'){
                this.dataSource.filteredData = [];
                console.log("Printing only the Non evaluated data");
              //  this.dataSource.filteredData = this.matchingElementsNonEvaluated;
              console.log("11",this.matchingElementsNonEvaluated);
              this.matchingElementsNonEvaluatedWithoutDuplicates = this.removeDuplicatesInArray(this.matchingElementsNonEvaluated)
              console.log("12",this.matchingElementsNonEvaluatedWithoutDuplicates);
               this.dataSource = new MatTableDataSource(this.matchingElementsNonEvaluatedWithoutDuplicates);
                console.log("printing after push of Non Evaluated ",this.dataSource);
              }else if((this.optedValue == 'Show All')){
               this.dataSource.filteredData = [];
                console.log("Printing all the data");
               // this.dataSource.filteredData = this.allDataSourceArray;
                console.log("printing after push of All Data ",this.dataSource);
                this.allDataSourceArrayWithoutDuplicates = this.removeDuplicatesInArray(this.allDataSourceArray)
                this.dataSource = new MatTableDataSource(this.allDataSourceArrayWithoutDuplicates);
                
              }
              
            }
  }